import PropTypes from "prop-types";
import c from "classnames";
import { button } from "tags";

function DeleteButton({ onClick, children }) {
  const className = c("btn-alert", "btn-link", "btn-caps");
  return button({ className, type: "button", onClick }, children);
}

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default DeleteButton;
